// /**
//  * 全角转半角（只转换部分字符）
//  * @param {String} str - 需要处理的字符串
//  * @returns {String} 处理后的字符串
//  */
// export function fullToHalf(str: string): string {
//   return str
//     .replace(/／/g, '/')
//     .replace(/＆/g, '&')
//     .replace(/；/g, ';')
//     .replace(/＝/g, '=')
//     .replace(/＜br＞/g, '<br>')
//     .replace(/＜\/?div＞/g, '');
// }

/**
 * markdown 语法解析
 * @param {String} s - 需要处理的字符串
 * @returns {String} 处理后的字符串
 */
export function parseMarkdown(s: string): string {
  const str = xssFilter(s);
  return str.replace(/\[[^\]]+\]\([^)]+\)/g, (part) => {
    const keywords = part.match(/\[([^\]]+)\]\(([^)]+)\)/) as any[];
    return `<a href="${keywords[2]}">${keywords[1]}</a>`;
  });
}

/**
 * XSS 字符过滤
 * @param {String} str - 需要处理的字符串
 * @returns {String} 处理后的字符串
 */
export function xssFilter(str: string): string {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;');
}
